// helper function to convert redux selected filters
// to object that can be used for API
export const formatIdFilters = ({ data, queryParamKey }) =>
  // data is object where key is value and value is true/false of selection
  ({
    [queryParamKey]: Object.keys(data)
      .filter(k => data[k])
      .join(),
  });
export const formatStudentTags = ({ data, queryParamKey }) => {
  const { personalTags, officialTags } = data;
  const personal = Object.keys(personalTags).filter(k => personalTags[k]);
  const official = Object.keys(officialTags).filter(k => officialTags[k]);
  return { [queryParamKey]: [...personal, ...official].filter(t => t).join() };
};

export const formatActivities = ({ data }) =>
  Object.entries(data).reduce(
    (filters, [key, value]) => ({
      ...filters,
      [value.queryParam]: key,
    }),
    {},
  );

export const formatClassYear = ({ data }) =>
  Object.keys(data)?.length
    ? {
        classYear: Object.keys(data),
      }
    : {};

export const formatAlphaLastName = ({ data }) => {
  const keys = Object.keys(data);
  return keys?.length
    ? {
        min_last_name: keys[0].split(',')[0],
        max_last_name: keys[0].split(',')[1],
      }
    : {};
};

export const formatBulkIdentifierMatch = ({ data }) => {
  const keys = Object.keys(data);
  // force to have non empty value here for bulk match
  return keys?.length
    ? {
        [keys[0]]: { selected: true },
      }
    : {};
};
